import cacheSmartDocDataAction from '../actions/cacheSmartDocDataAction';
import { ClientItem } from 'owa-mail-store';
import ExtendedPropertyType from 'owa-service/lib/contract/ExtendedPropertyType';
import { trace } from 'owa-trace';

const ENTITYID_KEY = '@EntityId';

export default function parseSmartDocProperty(
    item: ClientItem,
    extendedProperty: ExtendedPropertyType
): void {
    let validProperty: boolean = false;

    if (item) {
        if (extendedProperty) {
            try {
                const parsedProperty = JSON.parse(extendedProperty.Value)[0];
                validProperty = extractAndCacheSmartDocDataFromProperty(item, parsedProperty);
            } catch (e) {
                trace.warn(
                    '[parseSmartDocProperty] Malformed property, cannot parse. Error: ' + e.message
                );

                (e as { networkError?: boolean }).networkError = true;
                throw e;
            }
        } else {
            trace.info('[parseSmartDocProperty] No property found.');
        }

        // If the property is valid, extractAndCacheSmartDocDataFromProperty will have cached the data.
        // Otherwise, cache that there is no valid property on the item.
        if (!validProperty) {
            cacheSmartDocDataAction(item, validProperty);
        }
    } else {
        trace.info('[parseSmartDocProperty] No item.');
    }
}

/**
 * Exported for testing purposes only. Should not be used otherwise.
 * @param item Item associated with smart doc property.
 * @param parsedProperty Parsed property to extract data from.
 */
export function extractAndCacheSmartDocDataFromProperty(
    item: ClientItem,
    parsedProperty: any
): boolean {
    let validProperty: boolean = false;

    // Extraction ID
    const smartDocExtractionID = parsedProperty[ENTITYID_KEY];

    // Initialize smart doc data if we have extraction ID.
    if (smartDocExtractionID) {
        validProperty = true;
        cacheSmartDocDataAction(item, validProperty, smartDocExtractionID);
    } else {
        trace.info('[extractAndCacheSmartDocDataFromProperty] Cannot parse entity ID. Aborting...');

        const error: Error = new Error('NoEntityIdOnProperty');
        throw error;
    }

    return validProperty;
}
